import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

/** 聯繫我們 - 頁面 */
@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
    contactForm: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        this.initForm();
    }

    /** 初始化表單 */
    initForm(): void {
        this.contactForm = this.formBuilder.group({
            FirstName: ['', Validators.required],
            FamilyName: ['', Validators.required],
            Company: [''],
            JobTitle: [''],
            Mail: ['', Validators.required],
            Phone: [''],
            Subject: ['', Validators.required],
            Content: [''],
        });
    }

    /** 送出表單 */
    onSubmitContact(): void {
        if (this.contactForm.invalid)
            return this.markAllCtrDirty(this.contactForm);

        const param = { ...this.contactForm.value };
        Object.keys(param).forEach(x => (param[x] = param[x] || ''));

        const target = 'service@kunyoutech.com.tw';
        const subject = encodeURIComponent(param.Subject);
        const body = encodeURIComponent(
            `姓名：${param.FirstName} ${param.FamilyName}\n` +
                `公司：${param.Company}\n` +
                `職稱：${param.JobTitle}\n` +
                `信箱：${param.Mail}\n` +
                `電話：${param.Phone}\n` +
                `問題與反應：${param.Content}`,
        );

        const href = `mailto:${target}?subject=${subject}&body=${body}`;
        const anchor = document.createElement('a');
        anchor.href = href;
        anchor.click();
    }

    /** 標示表單為 Dirty */
    markAllCtrDirty(form: FormGroup) {
        Object.keys(form.controls).forEach(key => form.get(key).markAsDirty());
    }
}
